import React, { FunctionComponent } from 'react';

type Props = {
  items: string[];
  className?: string;
};

export const Presentation: FunctionComponent<Props> = ({
  items,
  className = 'condition-text-list-item',
}) => {
  if (!items || items.length === 0) return null;
  return (
    <div className="condition-text-list">
      {items.map((item, index) => (
        <span key={index} className={className}>
          {item}
        </span>
      ))}
    </div>
  );
};
